<template>
  <div>
    <div class="d-flex justify-content-end mb-1">
      <b-button
        variant="primary"
        @click="openModal('add')"
      >
        <feather-icon icon="PlusIcon" />
        {{ t('Add') }}
      </b-button>
    </div>
    <b-card>
      <b-table
        sticky-header
        responsive="true"
        :items="parameterList.data"
        :fields="userFields"
        @row-contextmenu="contextmenu"
        @sort-changed="sortChanged"
      >
        <template #cell(status)="data">
          <span
            v-if="data.item.status === 'A'"
          >Active</span>
          <span
            v-if="data.item.status === 'I'"
          >In-Active</span>
        </template>
      </b-table>
      <b-row v-if="parameterList.total">
        <b-col
          cols="4"
          class="d-flex"
        >
          <div class="align-self-center pr-2">
            {{ t('Total Entries') + " " + parameterList.total }}
          </div>
          <b-form-group class="align-self-center mb-0">
            <label class="d-inline-block text-sm-left mr-50">{{ t('Per page') }}</label>
            <b-form-select
              id="perPageSelect"
              v-model="form.size"
              size="sm"
              :options="tableFilter.pageOptions"
              class="w-70"
              @change="getParameterList"
            />
          </b-form-group>

        </b-col>
        <b-col cols="8">
          <pagination
            :data="parameterList"
            :limit="2"
            class="pt-1 justify-content-end"
            @pagination-change-page="getResults"
          />
        </b-col>
      </b-row>
    </b-card>
    <vue-context
      ref="parameterContextMenu"
    >
      <li>
        <b-link
          class="d-flex align-items-center"
          @click="openModal('edit')"
        >
          <feather-icon
            icon="EditIcon"
            size="16"
          />
          <span class="ml-75">{{ t('Edit') }}</span>
        </b-link>
      </li>
    </vue-context>
    <create-parameter
      :parameter-data="parameterData"
    />
  </div>
</template>

<script>
import {
  BButton, BCard, VBToggle,
} from 'bootstrap-vue'
import { useUtils } from '@core/libs/i18n'
import VueContext from 'vue-context'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import axios from '@/utils/axiosCompany'
import store from '@/store'
import constants from '@/constants'
import CreateParameter from './CreateParameter.vue'
import { tableFilter, showLoader, hideLoader } from '@/utils/common'

export default {
  components: {
    BButton,
    BCard,
    CreateParameter,
    VueContext,
  },
  directives: {
    'b-toggle': VBToggle,
  },
  setup() {
    const { t } = useUtils()
    return { t }
  },
  data() {
    return {
      tableFilter,
      valuesContext: {},
      form: {
        size: 10,
        sortBy: 'para_id',
        sortOrder: 'desc',
        polymer_type: '',
        start_date: null,
        end_date: null,
        period: '',
      },
      parameterList: [],
      parameterData: [],
    }
  },
  computed: {
    userFields() {
      return [
        { key: 'para_id', label: this.$i18n.t('Para Id'), sortable: true },
        { key: 'para_value', label: this.$i18n.t('Para Value'), sortable: true },
        { key: 'parent_name', label: this.$i18n.t('Para Parent Value'), sortable: true },
        { key: 'para_desc', label: this.$i18n.t('Para Description'), sortable: true },
        { key: 'para_tech_desc', label: this.$i18n.t('Para Tech Desc'), sortable: true },
        { key: 'status', label: this.$i18n.t('Status'), sortable: true },
      ]
    },
  },
  mounted() {
    this.getParameterList()
    this.$root.$on('refreshParameterList', () => {
      this.getResults()
    })
  },
  methods: {
    contextmenu(item, index, event) {
      event.preventDefault()
      this.valuesContext = item
      this.$refs.parameterContextMenu.open(event, item)
    },
    sortChanged(val) {
      this.form.sortBy = val.sortBy
      this.form.sortOrder = val.sortDesc ? 'desc' : 'asc'
      this.getParameterList()
    },
    async getResults(page = 1) {
      showLoader()
      // eslint-disable-next-line no-undef
      await axios.post(`/parameter/list?page=${page}`, this.form, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        },
      })
        .then(response => {
          this.parameterList = response.data.data
          hideLoader()
        })
      hideLoader()
    },
    async getParameterList() {
      showLoader()
      await store.dispatch('storeSetting/getParameter', this.form).then(response => {
        if (response.data.code === constants.SUCCESS) {
          this.parameterList = response.data.data
          // eslint-disable-next-line eqeqeq
        } else if (response.data.code == constants.ERROR_500) {
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Something Went Wrong!',
              icon: 'Danger',
              variant: 'danger',
              text: '',
            },
          })
        }
      }).catch(e => {
      // eslint-disable-next-line eqeqeq
        if (e.msg == 'Unauthenticated.') {
          this.$router.back()
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'No Permission',
              icon: 'Danger',
              variant: 'danger',
              text: '',
            },
          })
        } else {
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Something Went Wrong!',
              icon: 'Danger',
              variant: 'danger',
              text: '',
            },
          })
        }
      })
      hideLoader()
    },
    openModal(type) {
      this.parameterData = []
      if (type === 'add') {
        this.$bvModal.show('CreateParameterModal')
      }
      if (type === 'edit') {
        showLoader()
        this.parameterData = this.valuesContext
        this.$bvModal.show('CreateParameterModal')
        hideLoader()
      }
    },
    changeStatus(data) {
      this.$swal({
        title: this.$i18n.t('Are you sure ?'),
        text: data.status === 1 ? this.$i18n.t('You want to In-Activate Status') : this.$i18n.t('You want to Activate Status'),
        icon: 'warning',
        showCancelButton: true,
        cancelButtonText: this.$i18n.t('Cancel'),
        confirmButtonText: this.$i18n.t('Yes'),
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.onSubmit(data)
        }
      })
    },
    async onSubmit(data) {
      showLoader()
      await store.dispatch('storeSetting/CreateParameter',
        {
          para_id: data.para_id,
          title: data.title,
          status: data.status === 1 ? 0 : 1,
        }).then(response => {
        // eslint-disable-next-line eqeqeq
        if (response.data.code == constants.SUCCESS) {
          this.$swal({
            icon: 'success',
            title: this.$i18n.t('Success'),
            text: this.$i18n.t('Status is successfully Updated'),
            customClass: {
              confirmButton: 'btn btn-success',
            },
          })
          this.getParameterList()
          hideLoader()
        }
      })
    },
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-context.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
